module.exports = __webpack_public_path__ + "static/media/AWS Services use by Amusema.4baf731f.jpg";